import { InjectionToken } from '@angular/core';

export interface IRESTConfig {
	language: string;
	baseURL: string;
	webSocketURI: string;
	oauthNode: string;
}

export const RESTConfig = new InjectionToken<IRESTConfig>('Rest configuration.');



// WEBPACK FOOTER //
// ./src/app/angular-rest/RESTConfig.ts